import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Liechtenstein: Country = {
    identifier: "Liechtenstein",
    name: "Liechtenstein",
    countryCode: "LI",
    group: CountryGroup.EUROPE,
    isUNMember: true,
    flag: "🇱🇮",
    svgPath: "m 501.78175,313.6684 -0.218,-0.022 -0.041,0.002 -0.023,-0.145 0.013,-0.309 0.121,-0.404 0.026,0.066 0.015,0.085 0.025,0.09 0.014,0.11 0.045,0.113 0.082,0.107 0.026,0.102 -0.041,0.129 z",
}
